import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './components/Home';
import TicTacToe from './components/games/TicTacToe/TicTacToe';
import Snake from './components/games/Snake/Snake';
import BrickBreaker from './components/games/BrickBreaker/BrickBreaker';
import Tetris from './components/games/Tetris/Tetris';
import PacmanChase from './components/games/PacmanChase/PacmanChase';
import MazeSolver from './components/games/MazeSolver/MazeSolver';
import DotsAndBoxes from './components/games/DotsAndBoxes/DotsAndBoxes';
import Checkers from './components/games/Checkers/Checkers';
import MemoryGame from './components/games/MemoryGame/MemoryGame';
import RockPaperScissors from './components/games/RockPaperScissors/RockPaperScissors';
import WhackAMole from './components/games/WhackAMole/WhackAMole';
import MathQuiz from './components/games/MathQuiz/MathQuiz';
import NumberGuessing from './components/games/NumberGuessing/NumberGuessing';
import ColorMatching from './components/games/ColorMatching/ColorMatching';
import TypingSpeed from './components/games/TypingSpeed/TypingSpeed';
import Game2048 from './components/games/Game2048/Game2048';
import Sudoku from './components/games/Sudoku/Sudoku';
import SlidingPuzzle from './components/games/SlidingPuzzle/SlidingPuzzle';
import LightsOut from './components/games/LightsOut/LightsOut';
import ConnectFour from './components/games/ConnectFour/ConnectFour';
import Minesweeper from './components/games/Minesweeper/Minesweeper';
import Nonogram from './components/games/Nonogram/Nonogram';
import TowerOfHanoi from './components/games/TowerOfHanoi/TowerOfHanoi';
import Match3 from './components/games/Match3/Match3';
import WordSearch from './components/games/WordSearch/WordSearch';
import FlappyBird from './components/games/FlappyBird/FlappyBird';
import SpaceShooter from './components/games/SpaceShooter/SpaceShooter';
import Asteroids from './components/games/Asteroids/Asteroids';
import Pong from './components/games/Pong/Pong';
import BreakoutAdvanced from './components/games/BreakoutAdvanced/BreakoutAdvanced';
import AimTrainer from './components/games/AimTrainer/AimTrainer';
import ReactionTime from './components/games/ReactionTime/ReactionTime';
import PatternMemory from './components/games/PatternMemory/PatternMemory';
import ShapeSorter from './components/games/ShapeSorter/ShapeSorter';
import BallAvoider from './components/games/BallAvoider/BallAvoider';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/tic-tac-toe" element={<TicTacToe />} />
          <Route path="/snake" element={<Snake />} />
          <Route path="/brick-breaker" element={<BrickBreaker />} />
          <Route path="/tetris" element={<Tetris />} />
          <Route path="/pacman-chase" element={<PacmanChase />} />
          <Route path="/maze-solver" element={<MazeSolver />} />
          <Route path="/dots-and-boxes" element={<DotsAndBoxes />} />
          <Route path="/checkers" element={<Checkers />} />
          <Route path="/memory-game" element={<MemoryGame />} />
          <Route path="/rock-paper-scissors" element={<RockPaperScissors />} />
          <Route path="/whack-a-mole" element={<WhackAMole />} />
          <Route path="/math-quiz" element={<MathQuiz />} />
          <Route path="/number-guessing" element={<NumberGuessing />} />
          <Route path="/color-matching" element={<ColorMatching />} />
          <Route path="/typing-speed" element={<TypingSpeed />} />
          <Route path="/2048" element={<Game2048 />} />
          <Route path="/sudoku" element={<Sudoku />} />
          <Route path="/sliding-puzzle" element={<SlidingPuzzle />} />
          <Route path="/lights-out" element={<LightsOut />} />
          <Route path="/connect-four" element={<ConnectFour />} />
          <Route path="/minesweeper" element={<Minesweeper />} />
          <Route path="/nonogram" element={<Nonogram />} />
          <Route path="/tower-of-hanoi" element={<TowerOfHanoi />} />
          <Route path="/match3" element={<Match3 />} />
          <Route path="/word-search" element={<WordSearch />} />
          <Route path="/flappy-bird" element={<FlappyBird />} />
          <Route path="/space-shooter" element={<SpaceShooter />} />
          <Route path="/asteroids" element={<Asteroids />} />
          <Route path="/pong" element={<Pong />} />
          <Route path="/breakout-advanced" element={<BreakoutAdvanced />} />
          <Route path="/aim-trainer" element={<AimTrainer />} />
          <Route path="/reaction-time" element={<ReactionTime />} />
          <Route path="/pattern-memory" element={<PatternMemory />} />
          <Route path="/shape-sorter" element={<ShapeSorter />} />
          <Route path="/ball-avoider" element={<BallAvoider />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;